import React, { useContext } from 'react';
import { ToolbarContext, RicosContext } from 'ricos-context';
import { getLangDir } from 'wix-rich-content-common';
import { ColorPicker } from 'wix-rich-content-plugin-commons';
import { extractPalette, colorPicker } from './TextColorPicker.js';

const getConfigKey = (type) => ({
  "ricos-text-color": "TEXT_COLOR",
  "ricos-text-highlight": "TEXT_HIGHLIGHT"
})[type];
const TextColorController = ({ type, closeModal }) => {
  var _a;
  const {
    isMobile,
    locale,
    getEditorCommands,
    colorPickerData: {
      [getConfigKey(type)]: { colorScheme, getUserColors = () => [], onColorAdded = () => {
      } }
    }
  } = useContext(ToolbarContext);
  const palette = extractPalette(colorScheme);
  const paletteColors = isMobile ? palette.slice(0, 5) : palette.slice(0, 6);
  const currentColor = (_a = getEditorCommands()) == null ? void 0 : _a.getColor(type);
  const onChange = ({ color }) => {
    var _a2;
    (_a2 = getEditorCommands()) == null ? void 0 : _a2.insertDecoration(type, { color });
    closeModal();
  };
  const onCustomColorAdded = ({ color }) => onColorAdded(color);
  const onResetColor = () => {
    var _a2;
    (_a2 = getEditorCommands()) == null ? void 0 : _a2.deleteDecoration(type);
    closeModal();
  };
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement("div", { dir: getLangDir(locale) }, /* @__PURE__ */ React.createElement(
    ColorPicker,
    {
      color: currentColor,
      palette: paletteColors,
      userColors: getUserColors().slice(-12),
      onColorAdded: onCustomColorAdded,
      isMobile,
      onChange,
      t,
      onResetColor
    },
    colorPicker({ isMobile, header: t("Color_Picker_TextColorButton_Header") })
  ));
};

export { TextColorController };
//# sourceMappingURL=TextColorController.js.map
